import { openDrawer } from "@/src/components/dialogs";
import { Service, User } from "@/src/data/allTypes";
import { USER } from "@/src/data/globalVariables";
import apiFetch from "@/src/utils/apiFetch";
import {
  getHospitalId,
  getUserShortName,
  isAdmin,
  isCabinet,
  isSuperAdmin,
} from "@/src/utils/utils";

import { CheckboxCard } from "@/src/components/cards";
import { MyDynamicSelect } from "@/src/components/dynamicSelect";
import { FetchableList } from "@/src/components/fetchableLists";
import { Input } from "@/src/components/universalInput";
import { UploadSpot } from "@/src/components/uploadSpots";
import { getItemId, getRemedType, uid } from "@/src/utils/utils";
import { useState } from "react";

export async function openTargetUsersDrawer({
  targetUsers,
  serviceId,
  onConfirm,
}: {
  targetUsers: User[];
  serviceId: string | null | undefined;
  onConfirm: (targetUsers: User[]) => void;
}) {
  await openDrawer({
    id: "usersCheckboxList",
    title: "Choisir les médecins à notifier",
    content: (
      <UsersCheckboxList
        serviceId={serviceId}
        selectedUsers={targetUsers}
        onChange={(newUsers) => {
          targetUsers = newUsers;
        }}
      ></UsersCheckboxList>
    ),
    onConfirm: async () => {
      await onConfirm?.(targetUsers);
    },
  });
}

export function UserForm({
  serviceId,
  current,
  onChange,
}: {
  serviceId?: string | null | undefined;
  current?: User;
  onChange: (newValue: User) => void;
}) {
  let [user, setUser] = useState(current || ({} as User));
  function setNewValue(newValue: User) {
    setUser(newValue);
    onChange(newValue);
  }

  return (
    <div className="grid c1 gap10">
      <UploadSpot
        value={user.profilePic}
        onChange={(newValue) => {
          setNewValue({ ...user, profilePic: newValue });
        }}
      ></UploadSpot>
      <Input
        name={"Nom"}
        type={"text"}
        value={user.lastName}
        onChange={(newValue) => {
          setNewValue({ ...user, lastName: newValue });
        }}
      />
      <Input
        name={"Prénom"}
        type={"text"}
        value={user.firstName}
        onChange={(newValue) => {
          setNewValue({ ...user, firstName: newValue });
        }}
      />
      <Input
        name={"Email"}
        type={"text"}
        isRequired={true}
        value={user.email}
        onChange={(newValue) => {
          setNewValue({ ...user, email: newValue });
        }}
      />
      {(isSuperAdmin(USER.get()) ||
        isAdmin(USER.get()) ||
        getItemId(USER.get()) == getItemId(user.creator) ||
        getItemId(USER.get()) == getItemId(user)) && (
        <Input
          name={"Mot de passe"}
          type={"password"}
          value={user.password}
          onChange={(newValue) => {
            setNewValue({ ...user, password: newValue });
          }}
        />
      )}
      {isSuperAdmin(USER.get()) && (
        <Input
          name={"Identifiant patient"}
          type={"text"}
          value={user.patientId}
          onChange={(newValue) => {
            setNewValue({ ...user, patientId: newValue });
          }}
        />
      )}
      {((serviceId == null && isAdmin(USER.get()) && getRemedType() != "ECG") ||
        isSuperAdmin(USER.get())) && (
        <MyDynamicSelect
          queryFn={apiFetch("services", "loadMany", {
            // hospitalId: getHospitalId(),
          })}
          queryKey={["loadServices", getHospitalId()]}
          valueContructor={(item) => item.id}
          nameConstructor={(item) => item.name}
          placeholder={"Choisir un service"}
          name={"Service"}
          value={user.service?.id}
          onChange={(newValue) => {
            setNewValue({ ...user, service: newValue });
          }}
        />
      )}
      {((serviceId == null && isAdmin(USER.get()) && getRemedType() != "ECG") ||
        isSuperAdmin(USER.get())) && (
        <MyDynamicSelect
          queryFn={apiFetch("roles", "loadMany", {
            showAll: isSuperAdmin(USER.get()),
          })}
          queryKey={["loadRoles"]}
          valueContructor={(item) => item.id}
          nameConstructor={(item) => item.name}
          placeholder={"Choisir un role"}
          name={"Role"}
          value={user.role?.id}
          onChange={(newValue) => {
            setNewValue({ ...user, role: newValue });
          }}
        />
      )}
      {isCabinet() && (
        <MyDynamicSelect
          queryFn={apiFetch("roles", "loadMany", { showCabinetOnly: true })}
          queryKey={["loadRoles"]}
          valueContructor={(item) => item.id}
          nameConstructor={(item) => item.name}
          placeholder={"Choisir un role"}
          name={"Role"}
          value={user.role?.id}
          onChange={(newValue) => {
            setNewValue({ ...user, role: newValue });
          }}
        />
      )}
      <MyDynamicSelect
        queryFn={apiFetch("specialities", "loadMany", {})}
        queryKey={["loadSpecialities"]}
        valueContructor={(item) => item.id}
        nameConstructor={(item) => item.name}
        placeholder={"Choisir une spécialité"}
        name={"Spécialité"}
        value={user.speciality?.id}
        onChange={(newValue) => {
          setNewValue({ ...user, speciality: newValue });
        }}
      />

      {((serviceId == null && isAdmin(USER.get()) && getRemedType() != "ECG") ||
        isSuperAdmin(USER.get())) && (
        <MyDynamicSelect
          queryFn={apiFetch("boxes", "loadMany", {
            // hospitalId: getHospitalId(),
            serviceId: getItemId(user.service),
          })}
          queryKey={["loadBoxes", getHospitalId(), getItemId(user.service)]}
          valueContructor={(item) => item.id}
          nameConstructor={(item) => item.name}
          placeholder={"Choisir un boxe préféré"}
          name={"Boxe préféré"}
          value={getItemId(user.preferredBox)}
          onChange={(newValue) => {
            setNewValue({ ...user, preferredBox: newValue });
          }}
        />
      )}
      {((serviceId == null && isAdmin(USER.get()) && getRemedType() != "ECG") ||
        isSuperAdmin(USER.get())) && (
        <MyDynamicSelect
          queryFn={apiFetch("structureUnits", "loadMany", {
            // hospitalId: getHospitalId(),
            serviceId: getItemId(user.service),
          })}
          queryKey={[
            "loadStructureUnits",
            getHospitalId(),
            getItemId(user.service),
          ]}
          valueContructor={(item) => item.id}
          nameConstructor={(item) => item.name}
          placeholder={"Choisir une unité"}
          name={"Unité"}
          value={getItemId(user.structureUnit)}
          onChange={(newValue) => {
            setNewValue({ ...user, structureUnit: newValue });
          }}
        />
      )}
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
    </div>
  );
}

export function UsersCheckboxList({
  specialityIds,
  excludedSpecialityIds,
  hospitalId,
  serviceId,
  roleId,
  selectedUsers,
  onChange,
}: {
  specialityIds?: string[] | null | undefined;
  excludedSpecialityIds?: string[] | null | undefined;
  hospitalId?: string | null | undefined;
  serviceId?: string | null | undefined;
  roleId?: string | null | undefined;
  selectedUsers: User[];
  onChange: (newValue: User[]) => void;
}) {
  const [reload, setReload] = useState(0);
  const [selectedService, setSelectedService] = useState<
    Service | null | undefined
  >(null);
  const [value, setValue] = useState(selectedUsers);
  let [searchKey, setSearchKey] = useState("");

  return (
    <div className="c1 gap15">
      <MyDynamicSelect
        queryFn={apiFetch("services", "loadMany", {
          // hospitalId: getHospitalId(),
        })}
        queryKey={["loadServices", getHospitalId()]}
        valueContructor={(item) => item.id}
        nameConstructor={(item) => item.name}
        placeholder={"Choisir un service"}
        name={"Service"}
        value={serviceId || selectedService?.id}
        onChange={(newId, newValue) => {
          setSelectedService(newValue);
        }}
      />
      <FetchableList
        queryKey={[
          "UsersCheckboxList",
          searchKey,
          hospitalId,
          serviceId,
          roleId,
          selectedService?.id,
          reload,
        ]}
        queryFn={() =>
          apiFetch("users", "loadMany", {
            searchKey,
            hospitalId,
            serviceId: selectedService?.id || serviceId,
            rolesIds: roleId ? [roleId] : undefined,
            excludedSpecialityIds,
            specialityIds,
          })
        }
        searchKey={searchKey}
        onSearch={(newValue) => {
          setSearchKey(newValue || "");
        }}
      >
        {(data) => (
          <div className={`usersList grid c1 mc1 gap10`}>
            {data?.map((user) => {
              if (!user) return null;
              return (
                <CheckboxCard
                  key={uid()}
                  color="blue"
                  title={getUserShortName(user)}
                  subTitle={user.speciality?.name}
                  status={
                    value.find((u) => u?.id == user?.id) != null
                      ? "active"
                      : "inactive"
                  }
                  onClick={async () => {
                    let newValue = value;
                    if (value.find((u) => u?.id == user?.id)) {
                      newValue = value.filter((u) => u?.id != user?.id);
                    } else {
                      newValue = [...value, user];
                    }
                    setValue([...newValue]);
                    onChange([...newValue]);
                  }}
                >
                  <div>{user.role?.name}</div>
                </CheckboxCard>
              );
            })}
          </div>
        )}
      </FetchableList>
    </div>
  );
}

export async function openUsersCheckboxList({
  serviceId,
  title,
  selectedUsers,
  onConfirm,
}: {
  serviceId: string | null | undefined;
  title: string | null | undefined;
  selectedUsers: User[];
  onConfirm: (newValue: User[]) => void;
}) {
  let targetUsers: User[] = [];
  await openDrawer({
    id: "usersCheckboxList",
    title: title || "Choisir les utilisateurs",
    content: (
      <UsersCheckboxList
        serviceId={serviceId}
        selectedUsers={selectedUsers}
        onChange={(newUsers) => {
          targetUsers = newUsers;
        }}
      ></UsersCheckboxList>
    ),
    onConfirm: async () => {
      await onConfirm(targetUsers);
    },
  });
}

export async function refreshUser() {
  let serverData = await apiFetch("general", "getServerData", {
    req: null as any,
    res: null as any,
  });
  sessionStorage.setItem("serverData", JSON.stringify(serverData));
  USER.set(serverData?.loggedInUser);
}
